module.exports = __webpack_public_path__ + "static/patent_etecube-febf9476af1f0286c8223c55b6b8b67c.png";